/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Volume_MetaInputs */

const en_us2_progress_volume_meta = /** @type {(inputs: Progress_Volume_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg per week`)
};

const pt_br2_progress_volume_meta = /** @type {(inputs: Progress_Volume_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg por semana`)
};

const es_419_progress_volume_meta = /** @type {(inputs: Progress_Volume_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg por semana`)
};

const pt_pt2_progress_volume_meta = /** @type {(inputs: Progress_Volume_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg por semana`)
};

const fr_fr2_progress_volume_meta = /** @type {(inputs: Progress_Volume_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg par semaine`)
};

const de_de2_progress_volume_meta = /** @type {(inputs: Progress_Volume_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg pro Woche`)
};

const it_it2_progress_volume_meta = /** @type {(inputs: Progress_Volume_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg a settimana`)
};

/**
* | output |
* | --- |
* | "kg per week" |
*
* @param {Progress_Volume_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_volume_meta = /** @type {((inputs?: Progress_Volume_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Volume_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_volume_meta(inputs)
	if (locale === "es-419") return es_419_progress_volume_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_volume_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_volume_meta(inputs)
	if (locale === "de-DE") return de_de2_progress_volume_meta(inputs)
	if (locale === "it-IT") return it_it2_progress_volume_meta(inputs)
	return en_us2_progress_volume_meta(inputs)
});
export { progress_volume_meta as "progress.volume_meta" }